import React from "react";
import { Row, Col } from "react-bootstrap";
import { useQuery } from "@apollo/client";
import { Link } from "react-router-dom";
import { faHammer, faLayerGroup, faShieldAlt } from "@fortawesome/free-solid-svg-icons";

import HeaderBox from "../../reuseableComponents/headerBox";
import { GET_APP_MENU } from "../../../queries/menuQrys/baseWLMenuQrys";
import SkeletonLoader from "../../reuseableComponents/loaders/SkeletonLoader";
import MenuCard from "../../reuseableComponents/MenuCard";
import ErrorHandler from "../../reuseableComponents/ErrorHandler";

const menuIcons = {
  IPS_DEF_ADMIN: faHammer,
  IPS_GRP_DEF_ADMIN: faLayerGroup,
  IPS_VIO_ADMIN: faShieldAlt
};

const IpsIndexPage = () => {
  const { loading, error, data } = useQuery(GET_APP_MENU, { variables: { menu: "IPS" } });
  if (loading || error)
    return (
      <div className='page-container ips-index-container'>
        <Row>
          <Col>
            <Link to='/' className='m-2 hyperlink' cypressid='home-page'>
              Home
            </Link>
            <span className='m-2'> | </span>
            <Link to='/secure/module-index' className='m-2 hyperlink' cypressid='modules-index'>
              Modules
            </Link>
          </Col>
        </Row>
        <Row>
          <Col>
            <HeaderBox id={"gray-primary"} cypressid='ipsIndexPage'>
              <h3 style={{ color: "#fff" }}>IPS Management</h3>
            </HeaderBox>
          </Col>
        </Row>
        <Row>
          <Col>{loading ? <SkeletonLoader width='100%' /> : error ? <ErrorHandler error={error} /> : ""}</Col>
        </Row>
      </div>
    );
  return (
    <div className='page-container ips-index-container'>
      <Row>
        <Col>
          <Link to='/' className='m-2 hyperlink' cypressid='home-page'>
            Home
          </Link>
          <span className='m-2'> | </span>
          <Link to='/secure/module-index' className='m-2 hyperlink' cypressid='modules-index'>
            Modules
          </Link>
        </Col>
      </Row>
      <Row>
        <Col>
          <HeaderBox id={"gray-primary"} cypressid='portalIndexPage'>
            <h3 style={{ color: "#fff" }}>IPS Management</h3>
          </HeaderBox>
        </Col>
      </Row>
      <Row>
        {data.getAppMenu.map((module) => (
          <Col md={4} key={module.value}>
            <MenuCard icon={menuIcons[module.value]} module={module.value} route={module.route} name={module.label} />
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default IpsIndexPage;
